
import React, { useLayoutEffect, useRef, useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import { SearchIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, DotsHorizontalIcon } from "@heroicons/react/outline";

const people = [
    {
        name: 'Lindsay Walton',
        title: 'Front-end Developer',
        email: 'lindsay.walton@example.com',
        role: 'Member',
    },
    // More people...
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


export default function BlockCards(){
    const checkbox = useRef()
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [selectedPeople, setSelectedPeople] = useState([])

    useLayoutEffect(() => {
        const isIndeterminate = selectedPeople.length > 0 && selectedPeople.length < people.length
        setChecked(selectedPeople.length === people.length)
        setIndeterminate(isIndeterminate)
        checkbox.current.indeterminate = isIndeterminate
    }, [selectedPeople])

    function toggleAll() {
        setSelectedPeople(checked || indeterminate ? [] : people)
        setChecked(!checked && !indeterminate)
        setIndeterminate(false)
    }
    return(<>
    <Layout title={'Block Cards'} pageTag={'cards'} current={'/block/card'}>
        <React.Fragment>
        <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="mt-1 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search customer"
                                        />
                                    </div>
                                    <div className="mt-1 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="currency"
                                            name="currency"
                                            placeholder="Sort by"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option>Sort by</option>
                                            <option>All</option>
                                            <option>Name</option>
                                            <option>Department</option>
                                            <option>Role</option>
                                        </select>

                                    </div>
                                </div>

                                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                                    <button
                                        type="button"
                                        className="inline-flex hover:text-white active:text-white mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                                    >
                                        <DocumentDownloadIcon className="w-4 mr-1.5" />
                                        Export CSV
                                    </button>
                                   
                                </div>
                            </div>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                                                     <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="relative w-12 px-6 sm:w-16 sm:px-8">
                                                            <input
                                                                type="checkbox"
                                                                className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                                ref={checkbox}
                                                                checked={checked}
                                                                onChange={toggleAll}
                                                            />
                                                        </th>
                                                        <th scope="col" className="min-w-[12rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                        Account Number
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                         Name on Card  
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Account Officer
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Branch
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Date Issued
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                           Description
                                                        </th>
                                                       
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Status
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {people.map((person) => (
                                                        <tr key={person.email} className={selectedPeople.includes(person) ? 'bg-gray-50' : undefined}>
                                                            <td className="relative w-12 px-6 sm:w-16 sm:px-8">
                                                                {selectedPeople.includes(person) && (
                                                                    <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                                                                )}
                                                                <input
                                                                    type="checkbox"
                                                                    className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6"
                                                                    value={person.email}
                                                                    checked={selectedPeople.includes(person)}
                                                                    onChange={(e) =>
                                                                        setSelectedPeople(
                                                                            e.target.checked
                                                                                ? [...selectedPeople, person]
                                                                                : selectedPeople.filter((p) => p !== person)
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className={classNames(
                                                                    'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                                                                    selectedPeople.includes(person) ? 'text-indigo-600' : 'text-gray-900'
                                                                )}
                                                            >
                                                                {person.name}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.title}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.email}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.role}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.title}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.email}</td>
                                                            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                <Link to=" " className="text-gray-600 ">
                                                                    <DotsHorizontalIcon /> <span className="sr-only">, {person.name}</span>

                                                                </Link>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
        </React.Fragment>
        </Layout></>)
}